import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { FaLinkedinIn, FaFacebookF } from "react-icons/fa";
import { SlSocialInstagram } from "react-icons/sl";
import { NavLink } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';

const Footer = () => {
  const isMobile = useMediaQuery({ query: '(max-width: 991px)' });
  return (
    <div className='footer '>
    
      <div className='text-center copyright'>
        <Container>
        {isMobile ?
          <>
            <p>© All trademarks, logos and names are properties of their respective owners.</p>
            <p>All Rights Reserved. © Copyright 2024 IRA Reality Tech Private Limited. </p>
          </>
          :
          <span>©At VeeraSynergies Pvt. Ltd., we don’t just deliver projects – we deliver excellence.</span>
        }
        </Container>
      </div>
    </div>
  )
}

export default Footer
